import React, { useState } from 'react'
import { Mail, Phone, Linkedin, Facebook, ChevronUp } from 'lucide-react'
import { InstagramLogoIcon } from '@radix-ui/react-icons'
// import Logo from './Images/Trisolution/Logo.svg'
// import Fundo from './Images/Trisolution/Fundo.svg'
// import Fundopt3 from './Images/Trisolution/Fundopt3.svg'
// import Login from './Images/Trisolution/Login.svg'

const Header: React.FC = () => {
  return (
    <header className="bg-[#0B2253] w-full text-xs text-white font-normal">
      <div className="bg-[#0C224F] w-full h-[4px]" />
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-2">
        {/* <img src={Logo} alt="Trisolutions Logo" className="w-12 object-contain" /> */}

        {/* Container alinhado em linha */}
        <div className="flex items-center gap-6">
          <nav className="flex gap-4">
            <a href="#services" className="hover:bg-[#0E3B8A] py-2 px-3 rounded transition-colors">
              Serviços
            </a>
            <a href="#contact" className="hover:bg-[#0E3B8A] py-2 px-3 rounded transition-colors">
              Contato
            </a>
          </nav>
          <button className="hover:opacity-80 transition-opacity">
            {/* <img src={Login} alt="Login" className="w-8 h-8 object-contain" /> */}
          </button>
        </div>
      </div>
    </header>
  )
}

const HeroSection: React.FC = () => {
  return (
    <section className="relative w-full min-h-screen md:h-[750px] bg-cover bg-center flex items-center justify-center md:justify-start">
      {/* Fundo decorativo atrás do conteúdo */}
      {/* <img src={Fundo} alt="Fundo decorativo secundário" className="absolute inset-0 w-full h-full object-cover z-0 " /> */}

      {/* Conteúdo sobreposto ao fundo */}
      <div className="relative z-10 text-left w-full max-w-3xl px-6 md:px-8 md:ml-16">
        <h1 className="text-lg sm:text-xl md:text-4xl text-white font-normal leading-snug">
          <span className="font-semibold block">Transformamos seus direitos em resultados:</span>
          <span className="block">recuperamos seus créditos com precisão e transparência.</span>
        </h1>
        <div className="flex flex-wrap justify-start gap-4 mt-6">
          <a
            href="#contact"
            className="bg-[rgba(215,218,221,1)] text-[#0E3B8A] text-xs sm:text-sm font-medium py-2 px-6 sm:px-12 rounded-md hover:bg-[#c4c8cc] transition-colors"
          >
            ENTRE EM CONTATO
          </a>
        </div>
      </div>
    </section>
  )
}

const AboutSection: React.FC = () => {
  return (
    <section className="w-full px-10 py-12 bg-white">
      <h2 className="text-[#0C224F] text-xl font-bold mb-4">Quem Somos?</h2>
      <div className="text-black text-base font-normal leading-relaxed">
        Na Trisolutions, simplificamos o universo da tributação para que você possa focar no que realmente importa:
        fazer sua empresa crescer de forma sustentável.
        <br />
        <br />
        Com muita experiência e uma equipe altamente qualificada, oferecemos soluções personalizadas que otimizam seus
        processos fiscais, asseguram conformidade legal e eliminam surpresas desagradáveis. Nosso compromisso é ser o
        parceiro estratégico que você precisa para lidar com questões tributárias de forma eficiente, prática e segura.
        <br />
        <br />
        <span className="font-semibold">
          Tem dúvidas ou quer saber mais? Entre em contato conosco agora mesmo. Estamos prontos para ajudar você a
          alcançar seus objetivos com tranquilidade e confiança.
        </span>
      </div>
    </section>
  )
}

interface ServiceCardProps {
  title: string
  className?: string
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, className }) => {
  return (
    <div
      className={`bg-[#0E285F] text-white font-medium text-xs sm:text-sm rounded-md 
      w-full max-w-[300px] h-[160px] sm:h-[220px] flex items-center justify-center text-center  px-4 py-2
      ${className}`}
    >
      {title}
    </div>
  )
}

const ServicesSection: React.FC = () => {
  return (
    <section
      id="services"
      className="bg-[rgba(215,233,245,1)] w-full flex flex-col items-center text-white font-semibold mt-[109px] pt-[25px] px-4"
    >
      <h2 className="text-[#0C224F] text-xl font-bold mb-6">Áreas de Atuação</h2>

      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-2 max-w-3xl w-full justify-items-center">
        <ServiceCard title="Assessoria Tributária" />
        <ServiceCard title="Assessoria Jurídica Tributária" />
        <ServiceCard title="Consultoria" />
        <ServiceCard title="Licitações" />
        <ServiceCard title="Atendimento Personalizado" />
        <ServiceCard title="Contabilidade" />
      </div>

      {/* Imagem 100% da tela, fora do max-w */}
      <div className="w-screen mt-6">
        {/* <img src={Fundopt3} alt="Wave decoration" className="w-full object-cover mb-[-11px] mt-[27px]" /> */}
      </div>
    </section>
  )
}

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    tel: '',
    email: '',
    message: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    console.log('Form submitted:', formData)
    setFormData({
      name: '',
      tel: '',
      email: '',
      message: ''
    })
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[rgba(14,40,95,1)] w-full max-w-xl mx-auto flex flex-col text-sm text-white font-normal p-6 rounded-2xl"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col">
          <label htmlFor="name">Nome*</label>
          <input
            id="name"
            name="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            required
            className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="tel">Telefone*</label>
          <input
            id="tel"
            name="tel"
            type="tel"
            value={formData.tel}
            onChange={handleChange}
            required
            className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
          />
        </div>
      </div>

      <div className="flex flex-col mt-4">
        <label htmlFor="email">Email*</label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="bg-[rgba(217,217,217,0.26)] h-10 mt-1 rounded-xl px-3 text-white placeholder-white"
        />
      </div>

      <div className="flex flex-col mt-4">
        <label htmlFor="message">Mensagem*</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="bg-[rgba(217,217,217,0.26)] h-24 mt-1 rounded-xl px-3 py-2 text-white resize-none placeholder-white"
        />
      </div>

      <button
        type="submit"
        className="bg-[rgba(215,218,221,1)] text-[#0E3B8A] font-medium mt-6 py-3 rounded-xl hover:bg-[#c4c8cc] transition-colors"
      >
        ENVIAR
      </button>
    </form>
  )
}

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="flex flex-col items-center w-full">
      <h2 className="text-[#424242] text-sm font-bold mt-[45px]">Contato</h2>
      <div className="text-black text-xs font-normal mt-[35px] text-center">
        De segunda à sexta-feira das 09h00 às 18h00
        <br />
        ou entre em contato através do formulário abaixo.
      </div>
      <div className="w-full px-4">
        <div
          className="bg-[#0E285F] flex flex-col md:flex-row items-start md:items-center justify-between 
    text-xs text-white font-normal mt-6 px-6 py-4 rounded-2xl gap-4 md:gap-6 max-w-[400px] mx-auto w-full"
        >
          <div className="flex items-center gap-2">
            <Mail className="w-4 h-4" />
            <a href="mailto:contato@trisolutions.com.br" className="hover:underline">
              contato@trisolutions.com.br
            </a>
          </div>

          <div className="flex items-center gap-2">
            <Phone className="w-4 h-4" />
            <a href="tel:+553100000000" className="hover:underline">
              (31)0000-0000
            </a>
          </div>
        </div>
      </div>

      <div className="pt-10 w-full max-w-3xl px-4">
        <ContactForm />
      </div>
    </section>
  )
}

const Footer: React.FC = () => {
  return (
    <footer className="bg-[rgba(14,40,95,1)] w-full flex flex-col items-center px-6 py-10 mt-20">
      <h3 className="text-white text-sm font-extrabold">SIGA-NOS</h3>

      <div className="flex flex-col md:flex-row items-center justify-center    gap-6 w-full max-w-4xl mt-6 text-white text-xs font-medium text-center md:text-left">
        <div>
          Acompanhe a Trisolutions nas
          <br /> redes sociais
        </div>

        <div className="flex items-center gap-4">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <Facebook className="w-8 h-8 hover:opacity-80 transition-opacity" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <InstagramLogoIcon className="w-8 h-8 hover:opacity-80 transition-opacity" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <Linkedin className="w-8 h-8 hover:opacity-80 transition-opacity" />
          </a>
        </div>
      </div>
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 z-50 bg-[#0E285F] text-white p-3 rounded-full shadow-lg hover:bg-[#0C224F] transition-colors"
        aria-label="Voltar ao topo"
      >
        <ChevronUp className="w-5 h-5" />
      </button>
      <hr className="border-white w-full max-w-4xl my-8" />

      <div className="flex  md:flex-row justify-between items-start gap-8 w-full max-w-4xl text-white text-xs font-normal">
        <div className="flex items-start gap-4">
          {/* <img src={Logo} alt="Logo" className="w-12 object-contain" /> */}
          <nav className="flex flex-col space-y-1">
            <a href="#" className="hover:underline">
              Home
            </a>
            <a href="#contact" className="hover:underline">
              Contato
            </a>
            <a href="#services" className="hover:underline">
              Serviços
            </a>
          </nav>
        </div>

        <address className="not-italic leading-relaxed">
          <div className="font-bold mb-1">Endereço</div>
          Rua xx
          <br />
          Belo Horizonte - MG
          <br />
          CEP: 31310-000, Brasil
        </address>
      </div>
    </footer>
  )
}

const TrisolutionPage: React.FC = () => {
  return (
    <div className="bg-white w-full overflow-hidden mx-auto">
      <Header />
      <HeroSection />
      <main className="bg-white flex w-full flex-col items-center pt-6 mt-4">
        <AboutSection />
        <ServicesSection />
        <ContactSection />
        <Footer />
      </main>
    </div>
  )
}

export default TrisolutionPage
